import React, { useState, useEffect, useContext } from 'react';
import { RightOutlined } from '@ant-design/icons';
import { withRouter } from 'react-router-dom';
import { useSlideMenuCollapse } from '@/hooks/useSlideMenuCollapsedChange';
import DetailHeaderInfoWrapper from '@/components/detail-header-info-wrapper';
import Container from '@/components/container';
import Nav from '@/components/slide-menu/tab-nav';
import ProvideSideMenu from '@/components/slide-menu/provide-slide-menu';
import './index.less';

/*****************
 * 素材策略 - 商品策略 - 详情/触达详情 *
 *****************/

function customCrumb() {
  return (
    <div className="custom-crumb-fa">
      <div className="crumb-font" onClick={() => goto.materialPoolManage(channelId).push()}>
        素材维护触达记录
      </div>
    </div>
  );
}

export const StrategyDetailExtraHeaderProps = {
  backIcon: false,
  renderCrumbs: customCrumb,
  background:
    '#f5fbff url(//img30.360buyimg.com/pop/jfs/t1/94046/35/20488/11573/61d4310eEea40992d/c19a3c48ba28c35c.png) right bottom/325px no-repeat',
  btns: [],
};

const DailyGoodsStrategyDetail = withRouter((props) => {
  // // 隐藏侧边栏
  // useSlideMenuCollapse();
  const values = useContext(ProvideSideMenu);
  const { setShowNav, setHeaderExtraProps } = values;

  useEffect(() => {
    setShowNav(false);
    setHeaderExtraProps(StrategyDetailExtraHeaderProps);
    return () => {
      setShowNav(true);
      setHeaderExtraProps({});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="daily-goods-strategy-detail-wrapper">
      <div className="detail-body-fa">
        <Container>
          <ProvideSideMenu.Provider value={{ children: props.children }}>
            <Container margin={false} padding={{ horizontal: true }}>
              <Nav linkEndWithSearch={false} className="sub-nav-in-trend" />
            </Container>
            {/* 子路由 */}
            {props.children}
          </ProvideSideMenu.Provider>
        </Container>
      </div>
    </div>
  );
});

export default DailyGoodsStrategyDetail;
